import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText
} from 'reactstrap';
import { Link } from 'react-router-dom'
import {
  Loading
} from "common-import/custom";
import moment from 'moment';
const ReactMarkdown = require('react-markdown');
import { VarHelper } from '../../utils';
import { inject, observer } from 'mobx-react';

@inject('userStore') @observer
class SystemNotification extends Component {

  state = {
    isLoading: false,
    list: [],
    page: 'null', // null, authen, not authen
  }

  async componentDidMount() {
    const { userStore } = this.props;
    await userStore.onReady();
    if (userStore.isAuth()) {
      this.setState({ isLoading: true, page: 'authen' })
      await this.loadNotification();
      this.setState({ isLoading: false })
    } else {
      this.setState({ page: 'not authen' })
    }
    
  }

  loadNotification = async () => {
    const res = await fetch(encodeURI('https://api.mlab.com/api/1/databases/hl-noti/collections/chat-log?apiKey=eTs2gMpDmJrwzCrM-R5Iiw15zdYPkP3w&s={"timestamp": -1}&l=2'));
    const json = await res.json();
    console.log('json', json)
    this.setState({ list: json });
  }

  renderLoggedIn = () => {
    const { isLoading, list } = this.state;
    if (isLoading) return (<Loading> </Loading>);
    const btnStyle = { margin: 10};
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <i className="fa fa-user-o"> </i> Menu của bạn
              </CardHeader>
              <CardBody>
                <h4 className="h4">Xin chào, chúc bạn một ngày làm việc vui vẻ</h4>
                <ul className="ul">
                  <li><Link to='/contractors/list'>Danh sách dự án</Link></li>
                  <li><Link to='/projects/list'>Danh sách nhà thầu</Link></li>
                  <li><Link to='/tutorials'>Xem hướng dẫn</Link></li>
                </ul>
              </CardBody>  
            </Card>
          </Col>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"> </i> 2 log hệ thống gần nhất
              <div className="card-actions">
                  <Link to="/system-notifications">
                    <small className="text-muted">more</small>
                  </Link>
                </div>
              </CardHeader>
              <CardBody>
                {VarHelper.detectType(list) === 'array' && list.map((val, index) => (
                  <div key={"noti" + index} style={{ marginBottom: 10, borderBottom: '1px dashed black' }}>
                    <ReactMarkdown source={val.message} />
                    <p style={{ fontSize: 12, fontStyle: 'italic', color: 'grey' }}>{new Date(val.timestamp).toISOString()}</p>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const { page } = this.state;
    if (page === 'null') return null;
    if (page === 'not authen') return (
      <div className="animated fadeIn">
        Bạn cần đăng nhập để tiếp tục
      </div>
    )
    if (page === 'authen') return this.renderLoggedIn();
  }
}

export default SystemNotification;


// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js